var controller = new ScrollMagic.Controller();

$(function() {
  new ScrollMagic.Scene({
    triggerElement: "body:not(.legal-services):not(.request-segments-3) main",
    triggerHook: "onLeave",
    offset: "-300"
  })
    .setClassToggle("body:not(.legal-services):not(.request-segments-3) #search-app", "nav-dark") // add class toggle
    .addTo(controller)
    .on("enter", function() {
      // console.log("general enter")
      $("body:not(.legal-services):not(.request-segments-3) #nav-main").addClass("nav-dark");
    })
    .on("leave", function() {
      // console.log("general leave")
      $("body:not(.legal-services):not(.request-segments-3) #nav-main").removeClass("nav-dark");
    });

    new ScrollMagic.Scene({
        triggerElement: "body.legal-services.request-segments-3 main",
        triggerHook: "onLeave",
        offset: "300"
      })
      .setClassToggle("body.legal-services.request-segments-3 #search-app", "nav-dark") // add class toggle
      .addTo(controller)
      .on("enter", function () {
        // console.log("enter")
        $("body.legal-services.request-segments-3 #nav-main").addClass("nav-dark");
      })
      .on("leave", function () {
        // console.log("leave")
        $("body.legal-services.request-segments-3 #nav-main").removeClass("nav-dark");
      });

  var homepageSectionLength = $(".section-homepage").length;

  for (var i = 1; i <= homepageSectionLength; i++) {
    var tweenText = TweenMax.to(".fader" + i, 1, { opacity: 0 });
    var tweenPersonFadein = TweenMax.to("#person" + i, 1, { opacity: 1 });
    var tweenPersonFadeout = TweenMax.to("#person" + i, 1, { opacity: 0 });

    // fade out of text at the top
    new ScrollMagic.Scene({
      triggerElement: "#info-content" + i,
      triggerHook: "onLeave",
      duration: "200",
      offset: "-200"
    })
      .setTween(tweenText)
      .addTo(controller);

    // change active menu item
    new ScrollMagic.Scene({
      triggerElement: "#info-content" + i,
      duration: "100%",
      triggerHook: "onEnter"
    })
      .setClassToggle("#nav-menu li:nth-child(" + i + ")", "active")
      .addTo(controller);

    // fade out person
    new ScrollMagic.Scene({
      triggerElement: "#info-content" + i,
      triggerHook: "onLeave",
      duration: "100",
      offset: "-300"
    })
      .setTween(tweenPersonFadeout)
      .addTo(controller);

    // fade in person
    new ScrollMagic.Scene({
      triggerElement: "#info-content" + i,
      triggerHook: "onEnter",
      duration: "200",
      offset: "100"
    })
      .setTween(tweenPersonFadein)
      .addTo(controller);
  }
});



// WEBPACK FOOTER //
// ./scripts/scroll-magic.js